import { iconRequest, iconClient, iconSearch } from '../defaultValues';

const data = {
    role_526419d4f06442d5b5da0ff2cb8d6ad7: [
        {
            id: 'neww',
            icon: iconRequest,
            label: 'Garantía Vehicular',
            to: '/app/warranty',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },

        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
    ],
};
export default data;
